import { connect } from 'react-redux'

import { selectAction, collapseSidebarAction, editModeChangeAction, loadingAction, openPanelAction,
addModeChangeAction, changeShowFiltersAction, setAccessibilityVersionAction } from './actions'
import SidebarComponent from './SidebarComponent'

const mapStateToProps = state => {
  return {
  	places: state.places,
    selected: state.selected,
    collapsed: state.collapsed,
    editMode: state.editMode,
    loading: state.loading,
    showingFilters: state.showingFilters,
    authorizedUser: state.authorizedUser,
    accessibilityVersion: state.accessibilityVersion
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    onCollapseSidebar: collapsed => dispatch(collapseSidebarAction(collapsed)),
    onEditModeChange: editMode => dispatch(editModeChangeAction(editMode)),
    onLoading: loading => dispatch(loadingAction(loading)),
    openPanel: open => dispatch(openPanelAction(open)),
    onAddModeChange: mode => dispatch(addModeChangeAction(mode)),
    changeShowFilters: show => dispatch(changeShowFiltersAction(show)),
    setAccessibilityVersion: status => dispatch(setAccessibilityVersionAction(status)),
  }
}

const SidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarComponent)

export default SidebarContainer



// WEBPACK FOOTER //
// ./src/SidebarContainer.js